(function () {
  var noAnim = document.body.classList.contains('ev-no-anim');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky header shadow */
  var headerSection = document.querySelector('.ev-header');
  var headerWrap = headerSection ? headerSection.closest('[id^="shopify-section-"]') : null;
  function onScrollHeader() {
    if (headerWrap) headerWrap.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  /* Reveal on scroll */
  var revealEls = document.querySelectorAll('.ev-reveal');
  if ('IntersectionObserver' in window && !noAnim && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Canopy parallax */
  var strength = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--plx-strength')) || 0.6;
  var plxEls = Array.prototype.slice.call(document.querySelectorAll('[data-plx]'));
  var ticking = false;
  function applyParallax() {
    ticking = false;
    if (noAnim || reduced || strength <= 0) return;
    var vh = window.innerHeight;
    plxEls.forEach(function (el) {
      var rect = el.parentElement.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > vh + 100) return;
      var depth = parseFloat(el.dataset.depth || '0.2');
      var center = rect.top + rect.height / 2;
      var offset = (center - vh / 2) * depth * strength * 0.35;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    });
  }
  function requestParallax() {
    if (!ticking) { ticking = true; requestAnimationFrame(applyParallax); }
  }
  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax);
  applyParallax();

  /* Reading progress */
  var bar = document.querySelector('[data-read-progress]');
  var body = document.querySelector('[data-article-body]');
  if (bar && body) {
    function onProgress() {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var done = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      bar.style.width = (total > 0 ? (done / total) * 100 : 100) + '%';
    }
    window.addEventListener('scroll', onProgress, { passive: true });
    onProgress();
  }

  /* Theme editor: re-collect on section load */
  document.addEventListener('shopify:section:load', function () {
    plxEls = Array.prototype.slice.call(document.querySelectorAll('[data-plx]'));
    applyParallax();
  });
})();
